import { render, staticRenderFns } from "./definition-du-facing.vue?vue&type=template&id=1b43f601&"
import script from "./definition-du-facing.vue?vue&type=script&lang=js&"
export * from "./definition-du-facing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports